import { useLocation, useNavigate } from "react-router-dom";
import useAuth from "../../../../hook/useAuth";
import useDelete from "../../../../hook/useDelete";
import useConfirm from "../../../../hook/useConfirm";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { baseURL } from "../../../../config/api";
import { validateMin } from "../../../../utils/validateMin";
import { CustomImagePopup } from "../../../../components/CustomImagePopup";
import { PleasewaitPopup } from "../../../../components/PleasewaitPopup";
import Select from "react-select";

export const EditWheelProduct = () => {
    const navigate = useNavigate();
    const { auth }: any = useAuth();
    const idNumber = useLocation();
    const { setDeletePopup, setData: setDeleteData }: any = useDelete();
    const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
    const [price, setPrice] = useState<number>(0);
    const [sku, setSku] = useState<string>("");
    const [file, setFile] = useState<FileList | null>(null);
    const [filePath, setFilePath] = useState<string>("");
    const [imagePopup, setImagePopup] = useState<boolean>(false);
    const [brandId, setBrandId] = useState<number>(0);
    const [modelId, setModelId] = useState<number>(0);
    const [brands, setBrands] = useState<any[]>([]);
    const [models, setModels] = useState<any[]>([]);
    const [wheelFitments, setWheelFitments] = useState<any[]>([]);
    const [wheelFitmentId, setWheelFitmentId] = useState<any>({});
    const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);

    const inputFileRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        setPleaseWaitPopup(true);
        axios.get(`${baseURL}wheelBrands`)
            .then((response) => {
                setBrands(response?.data?.map((item: any) => {
                    return { value: item.brandId, label: item.brandName }
                }))
                setPleaseWaitPopup(false);
            }).catch(error => {
                setBrandId(0);
                setBrands([]);
                console.error(error);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (brandId > 0) {
            setPleaseWaitPopup(true);
            axios.get(`${baseURL}wheelModels/GetWheelModelsByWheelBrandId/${brandId}`)
                .then((response) => {
                    setModels(response?.data?.map((item: any) => {
                        return { value: item.modelId, label: item.modelName }
                    }))
                    setPleaseWaitPopup(false);
                }).catch(error => {
                    setModelId(0);
                    setBrands([]);
                    console.error(error);
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [brandId])


    useEffect(() => {

        setPleaseWaitPopup(true);
        axios.get(`${baseURL}wheelFitments`)
            .then((response) => {
                setWheelFitments(response?.data?.map((item: any) => {
                    return { value: item.wheelFitmentID, label: `${item?.wheelWidth ? item?.wheelWidth + "/" : ""} R${item?.rimDiameter} ${item?.isCommercial ? "C" : ""} - ${item?.boltPattern}` }
                }))
                setPleaseWaitPopup(false);
            }).catch(error => {
                setWheelFitmentId(0);
                setBrands([]);
                console.error(error);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    useEffect(() => {
        if (Number(idNumber?.state) > 0 && wheelFitments.length > 0) {
            setPleaseWaitPopup(true);
            axios
                .get(`${baseURL}wheelProducts/${idNumber?.state}`)
                .then((response) => {
                    setBrandId(response?.data?.brandId)
                    setModelId(response?.data?.modelId)
                    const selectedWheelFitment = wheelFitments?.find((_: any) => response?.data?.wheelFitmentID === _?.value);
                    setWheelFitmentId(selectedWheelFitment)
                    setSku(response?.data?.sku)
                    setPrice(response?.data?.price)
                    setFilePath(response?.data?.productImage ? response?.data?.productImage : "")
                    setPleaseWaitPopup(false);
                })
                .catch((error) => {
                    setPleaseWaitPopup(false);
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idNumber, wheelFitments]);


    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setPleaseWaitPopup(true);
        if (file) {
            const formData = new FormData();
            formData.append("ImageFile", file[0]);

            try {
                const response = await axios.post(`${baseURL}commonFile/upload`, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    },
                    withCredentials: false,
                });
                saveTireProduct(response.data);

            } catch (err) {
                setConfirmData({
                    title: 'Warning',
                    summary: "An error occurred while uploading the image. Please try again.",
                    confirmBtn: 'Ok',
                    isConfirm: (callback: any) => {
                        callback();
                    }
                });

                setConfirmPopup(true);

                setPleaseWaitPopup(false);
            }


        }
        else {
            saveTireProduct("");
        }
    }

    const saveTireProduct = (imageFile: string) => {
        axios
            .put(
                `${baseURL}wheelProducts?userId=${auth?.id}`,
                JSON.stringify({
                    wheelId: idNumber?.state,
                    brandId,
                    modelId,
                    wheelFitmentID: wheelFitmentId?.value,
                    sku,
                    price,
                    productImage: imageFile ? imageFile : filePath
                }),
                {
                    headers: { "Content-Type": "application/json" },
                    withCredentials: false,
                }
            )
            .then((response) => {
                setPleaseWaitPopup(false);
                navigate(-1);
            })
            .catch((error) => {
                setPleaseWaitPopup(false);
                console.error("Error:", error);
            });
    }

    const onFileChangeCapture = (e: React.ChangeEvent<HTMLInputElement>) => {
        /*Selected files data can be collected here.*/
        const selectedFiles = e.target.files as FileList;

        if (selectedFiles && selectedFiles.length > 0) {
            const file = selectedFiles[0];
            const fileName = file.name.toLowerCase();

            const supportedExtensions = ['.jpg', '.jpeg', '.png', '.heif'];

            const isSupported = supportedExtensions.some(ext => fileName.endsWith(ext));

            if (isSupported) {
                setFile(selectedFiles);
            } else {
                console.error('Unsupported file type');
                setConfirmData({
                    title: 'Warning',
                    summary: "Unsupported file type",
                    confirmBtn: 'Ok',
                    isConfirm: (callback: any) => {
                        callback();
                    }
                });

                setConfirmPopup(true);
            }
        }
    };


    const handleDeleteImage = () => {
        setDeleteData({
            id: 0,
            tilte: `Delete`,
            summary: `Are you sure you want to delete this Image?`,
            isDelete: async (callback: any) => {
                if (inputFileRef.current) {
                    inputFileRef.current.value = '';
                }
                if (filePath) {
                    setFilePath("")
                }
                setFile(null);

                callback();
            }
        });

        setDeletePopup(true);
    }

    const deletingWheelProduct = async () => {

        setDeleteData({
            id: idNumber?.state,
            title: `Delete`,
            summary: `Are you sure you want to delete this wheel product?`,
            isDelete: (callback: any) => {
                setPleaseWaitPopup(true);
                callback();

                axios
                    .delete(`${baseURL}wheelProducts?id=${idNumber?.state}&userId=${auth?.id}`)
                    .then(() => {
                        setPleaseWaitPopup(false);
                        navigate(-1);
                    })
                    .catch((error) => {
                        setConfirmData({
                            title: "Warning",
                            summary: "Delete failed.",
                            confirmBtn: "Ok",
                            isConfirm: (cb: any) => cb(),
                        });

                        setConfirmPopup(true);
                        setPleaseWaitPopup(false);
                    });
            },
        });

        setDeletePopup(true);
    };

    return (
        <>
            <div className={`px-[24px] py-[20px] h-[calc(100vh-142px)] overflow-auto`}>
                <div className="w-full bg-white p-4 rounded-md">
                    <h2 className={`text-lg font-semibold`}>Edit Product</h2>

                    <div className="mt-2 p-2">
                        <form onSubmit={(e) => handleSubmit(e)}>
                            <div className="w-full">
                                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-6">
                                    {/* First Column */}
                                    <div className="space-y-4">
                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Brand</label>
                                            <select
                                                className={`w-full px-[8px] py-[8px] border border-secondary rounded-md outline-none focus:border-primary text-sm bg-transparent`}
                                                value={brandId}
                                                onChange={(e) => setBrandId(Number(e.target.value))}
                                                required
                                            >
                                                {brands?.map((brand: any) => (
                                                    <option key={brand.value} value={brand.value}>
                                                        {brand.label}
                                                    </option>
                                                ))}

                                            </select>
                                        </div>
                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Size</label>
                                            <Select
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    control: (baseStyles, state) => ({
                                                        ...baseStyles,
                                                        backgroundColor: "#ffffff",
                                                        color: "#2f3739",
                                                        borderRadius: '6px',
                                                        borderColor: state.isFocused ? "" : "#2f3739",
                                                        boxShadow: state.isFocused ? "0 0 0 1px #ea8616" : "",
                                                        "&: hover": {
                                                            borderColor: "#ea8616",
                                                        }

                                                    }),
                                                    menuPortal: (base) => ({
                                                        ...base,
                                                        zIndex: 9999
                                                    }),
                                                    menu: (base) => ({
                                                        ...base,
                                                        fontSize: "12px",
                                                        backgroundColor: "#ffffff",
                                                        color: "#2f3739",
                                                    }),
                                                    option: (base, state) => {
                                                        const isSelected = state.isSelected;
                                                        const isFocused = state.isFocused;
                                                        const selectedBg = "#ea8616";
                                                        const hoverBg = "#E6F0FA";
                                                        const defaultTextColor = "#000";

                                                        return {
                                                            ...base,
                                                            backgroundColor: isSelected
                                                                ? selectedBg
                                                                : isFocused
                                                                    ? hoverBg
                                                                    : "transparent",
                                                            color: isSelected ? "#fff" : defaultTextColor,
                                                            fontWeight: 500,
                                                            ':active': {
                                                                backgroundColor: isSelected ? selectedBg : hoverBg,
                                                            },
                                                        };
                                                    },
                                                    input: (base) => ({
                                                        ...base,
                                                        color: "#2f3739",

                                                    }),
                                                    singleValue: (base) => ({
                                                        ...base,
                                                        color: "#2f3739",
                                                    }),
                                                }}
                                                className="basic-single"
                                                classNamePrefix="select"
                                                isLoading={false}
                                                isClearable={true}
                                                isRtl={false}
                                                isSearchable={true}
                                                name="wheelFitmentId"
                                                value={wheelFitmentId}
                                                onChange={setWheelFitmentId}
                                                options={wheelFitments}
                                                required
                                            />

                                        </div>
                                        <div>
                                            <label className="block text-xs font-medium text-secondary">price</label>
                                            <input
                                                type="number"
                                                min={0}
                                                step={0.01}
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={price}
                                                placeholder="Price"
                                                onChange={(e) => setPrice(validateMin(e.target.value, 0))}
                                                required
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Image</label>
                                            {(file) && (
                                                <div className="flex flex-row items-center gap-[5px]">
                                                    {file && (
                                                        <img
                                                            src={URL.createObjectURL(file[0])}
                                                            width={40}
                                                            height={40}
                                                            alt="product"
                                                            className="cursor-pointer"
                                                            onClick={() => setImagePopup(true)}
                                                        />
                                                    )}

                                                    <span
                                                        className="material-symbols-outlined text-sm cursor-pointer hover:text-red-600"
                                                        onClick={handleDeleteImage}
                                                    >
                                                        do_not_disturb_on
                                                    </span>
                                                </div>
                                            )}
                                            <input
                                                type="file"
                                                accept="image/*"
                                                ref={inputFileRef}
                                                onChangeCapture={onFileChangeCapture}
                                                className="hidden"
                                            />
                                            <div className="flex flex-row gap-[8px] mt-[8px] cursor-pointer">
                                                <p
                                                    className="border border-dashed border-black rounded-[3px] px-[5px] py-[3px] flex justify-center items-center text-[12px] bg-white cursor-pointer"
                                                    onClick={(e) => {
                                                        if (inputFileRef.current) {
                                                            inputFileRef.current.value = "";
                                                        }
                                                        inputFileRef.current?.click();
                                                    }}
                                                >
                                                    <span className="material-symbols-outlined text-sm hover:text-primary">
                                                        add
                                                    </span>
                                                    Add Image
                                                </p>
                                            </div>
                                        </div>


                                    </div>

                                    <div className="space-y-4">
                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Model</label>
                                            <select
                                                className={`w-full px-[8px] py-[8px] border border-secondary rounded-md outline-none focus:border-primary text-sm bg-transparent`}
                                                value={modelId}
                                                onChange={(e) => setModelId(Number(e.target.value))}
                                                required
                                            >
                                                {models?.map((model: any) => (
                                                    <option key={model.value} value={model.value}>
                                                        {model.label}
                                                    </option>
                                                ))}

                                            </select>
                                        </div>
                                        <div>
                                            <label className="block text-xs font-medium text-secondary">SKU</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={sku}
                                                placeholder="SKU"
                                                onChange={(e) => setSku(e.target.value)}
                                                required
                                            />
                                        </div>

                                    </div>
                                </div>

                                {/* Buttons */}
                                <div className="flex flex-col sm:flex-row gap-4 mt-6">
                                    <button
                                        type="submit"
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-primary text-white cursor-pointer"
                                    >
                                        Save
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => navigate(-1)}
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-[#FFFFFF] text-primary cursor-pointer border border-primary"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => deletingWheelProduct()}
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-red-500 text-white cursor-pointer border border-red-600"
                                    >
                                        Delete
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <CustomImagePopup
                showPopup={imagePopup}
                handlePopup={() => setImagePopup(false)}
                filePath={file ? URL.createObjectURL(file[0]) : ""}
                imageBaseUrlPath="commonFile"

            />
            <PleasewaitPopup showPopup={pleaseWaitPopup} />
        </>
    )
}